<template>
  <router-view></router-view>
</template>

<script>

export default {
  
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  line-height: 1;
  font-size: 14px;
  font-weight: normal;
  list-style: none;
}
</style>
